import { render, staticRenderFns } from "./IlamliNafakaAlacakForm.vue?vue&type=template&id=59726fb3"
import script from "./IlamliNafakaAlacakForm.vue?vue&type=script&lang=ts"
export * from "./IlamliNafakaAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports